import {
  ModuleWidget,
  provideModuleWidgets,
  SOFTLINE_WIDGET_OUTLET_DASHBOARD,
} from '@softapps/core';
import { SOFTLINE_PERMISSION_CHECKLISTE } from '@softapps/core/checklist';

export function checklistWidgets(): ModuleWidget[] {
  return [
    {
      outletNames: [SOFTLINE_WIDGET_OUTLET_DASHBOARD],
      group: 'allgemein',
      loadComponent: () =>
        import('./checklist-widget/checklist-widget.component').then(
          (m) => m.ChecklistWidgetComponent
        ),
      permission: `${SOFTLINE_PERMISSION_CHECKLISTE}.WIDGET`,
    },
  ];
}

export function provideChecklistWidget() {
  return provideModuleWidgets(checklistWidgets());
}
